/** Native details supplies keyboard activation and expanded-state semantics. */
export function installActivityDrawer({root,releasePointer=()=>{},onOpen=()=>{}}) {
  const summary=root.querySelector('summary');
  const collapse=({focus=false}={})=>{root.open=false;if(focus)summary.focus();};
  const toggle=()=>{if(root.open){releasePointer();onOpen();const entries=root.querySelector('#activity-entries');entries.scrollTop=entries.scrollHeight;}};
  const keydown=event=>{if(event.key==='Escape'&&root.open){event.preventDefault();event.stopPropagation();collapse({focus:true});}};
  root.addEventListener('toggle',toggle);
  root.addEventListener('keydown',keydown);
  return {collapse,dispose(){root.removeEventListener('toggle',toggle);root.removeEventListener('keydown',keydown);}};
}
